export default {
  menu: []
}
